import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function WepriceLogo({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <polygon points="0,28 14,0 28,28" fill="#1a2e5a" />
      <polygon points="7,28 14,14 21,28" fill="#f5a623" />
    </svg>
  );
}

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash && location.pathname === "/") {
      const id = location.hash.replace("#", "");
      const scrollToSection = () => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          return true;
        }
        return false;
      };
      if (!scrollToSection()) {
        const retryInterval = setInterval(() => {
          if (scrollToSection()) clearInterval(retryInterval);
        }, 100);
        const timeout = setTimeout(() => clearInterval(retryInterval), 2000);
        return () => {
          clearInterval(retryInterval);
          clearTimeout(timeout);
        };
      }
    }
  }, [location.pathname, location.hash]);

  const scrollTo = (hash) => (e) => {
    e.preventDefault();
    navigate(`/${hash}`);
  };

  return (
    <nav className="wp-nav">
      <div className="wp-nav__inner">
        <a onClick={() => navigate("/")} className="wp-nav__logo">
          <WepriceLogo />
          <span className="wp-nav__logo-text">
            We<span>Price</span>
          </span>
        </a>

        <ul className="wp-nav__links">
          <li>
            <a href="/#how-it-works" onClick={scrollTo("#how-it-works")}>
              How it works
            </a>
          </li>
          <li>
            <a href="/#services" onClick={scrollTo("#services")}>
              Services
            </a>
          </li>
          <li>
            <a href="/#why-weprice" onClick={scrollTo("#why-weprice")}>
              Why WePrice
            </a>
          </li>
          <li>
            <a href="/#providers" onClick={scrollTo("#providers")}>
              For providers
            </a>
          </li>
        </ul>

        <div className="wp-nav__actions">
          <a
            className="wp-nav__signin"
            onClick={(e) => {
              e.preventDefault();
              navigate("/auth/login");
            }}
          >
            Sign in
          </a>
          <a
            className="wp-btn wp-btn--secondary"
            onClick={(e) => {
              e.preventDefault();
              navigate("/auth/register");
            }}
          >
            Join as a provider
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Header;
